import { getAllPatientsApi, getAllSearchedPatients } from '../api/patientApi';

export const FETCH_PATIENTS_REQUEST = 'FETCH_PATIENTS_REQUEST';
export const FETCH_PATIENTS_SUCCESS = 'FETCH_PATIENTS_SUCCESS';
export const FETCH_PATIENTS_FAILURE = 'FETCH_PATIENTS_FAILURE';
export const SET_PATIENTS_PAGE = 'SET_PATIENTS_PAGE';
export const SET_PATIENTS_PAGE_SIZE = 'SET_PATIENTS_PAGE_SIZE';

export const fetchPatients = (page, pageSize) => async (dispatch) => {
  dispatch({ type: FETCH_PATIENTS_REQUEST });

  try {
    const response = await getAllPatientsApi({ page, pageSize });
    console.log('response', response);

    dispatch({
      type: FETCH_PATIENTS_SUCCESS,
      payload: {
        patients: response.data.patients,
        totalPatients: response.data.totalUsers,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PATIENTS_FAILURE,
      payload: error.message,
    });
  }
};

export const fetchSearchedPatients =
  (page, pageSize, searchValue, searchByPatientId, searchByAadhaarNumber) =>
  async (dispatch) => {
    dispatch({ type: FETCH_PATIENTS_REQUEST });

    try {
      const response = await getAllSearchedPatients({
        page,
        pageSize,
        searchValue,
        searchByPatientId,
        searchByAadhaarNumber,
      });
      dispatch({
        type: FETCH_PATIENTS_SUCCESS,
        payload: {
          patients: response.data.patients,
          totalPatients: response.data.totalUsers,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_PATIENTS_FAILURE,
        payload: error.message,
      });
    }
  };

export const setPatientsPage = (page) => ({
  type: SET_PATIENTS_PAGE,
  payload: page,
});

export const setPatientsPageSize = (pageSize) => ({
  type: SET_PATIENTS_PAGE_SIZE,
  payload: pageSize,
});
